import { memo } from 'react';
import styles from '@components/ProductCardNew/ProductImage/PackshotImage/PackshotImage.styles';
import MissingPicturePlaceholder from '@components/ProductCardNew/ProductImage/MissingPicturePlaceholder/MissingPicturePlaceholder';
import ResponsiveImage from '@components/ResponsiveImage/ResponsiveImage';
import { IThumbnailFormats } from '@features/categories/typescript';
type PropsType = {
  url: string;
  alt: string;
  thumbnailFormats?: IThumbnailFormats;
  thumbnails?: Record<string, IThumbnailFormats | undefined>;
  onLoadFunc?: () => void;
  onErrorFunc?: () => void;
  standardLoaded?: boolean;
  showPlaceholder?: boolean;
  isBig?: boolean;
  isSmall?: boolean;
  isSlider?: boolean;
  isSearch?: boolean;
};
const PackshotImage = memo(({
  url,
  alt,
  thumbnailFormats,
  thumbnails,
  onLoadFunc,
  onErrorFunc,
  standardLoaded = true,
  showPlaceholder = false,
  isBig = false,
  isSmall = false,
  isSlider = false,
  isSearch = false
}: PropsType) => {
  if ((!url || url === '') && onErrorFunc) onErrorFunc();
  return <div sx={styles.packshostSpace(isBig, isSmall, isSlider, isSearch)}>
        <div sx={styles.imageContainer(!standardLoaded)}>
          {!standardLoaded && showPlaceholder && <MissingPicturePlaceholder />}
          <ResponsiveImage image={url} thumbnailFormats={thumbnailFormats} thumbnails={thumbnails} alt={alt} objectFit="contain" onLoad={onLoadFunc} onError={onErrorFunc} />
        </div>
      </div>;
});
PackshotImage.displayName = 'PackshotImage';
export default PackshotImage;